import EventList from './eventlist';

export default EventList;
